import React, { forwardRef } from 'react';
import './CardFrame.css';

const CardFrame = forwardRef(function CardFrame(props, ref) {
  const {
    className = '',
    children,

    shadow = 'soft',      // soft | normal | strong
    radius = '10px',      // px string
    hover = 'md',         // sm | md | lg | none
    padding = '2rem',     // rem string

    style,
    ...rest
  } = props;

  const classes = [
    'card-frame',
    `card-frame--shadow-${shadow}`,
    hover !== 'none' ? `card-frame--hover-${hover}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      ref={ref}
      className={classes}
      style={{
        padding,
        borderRadius: radius,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
});

export default CardFrame;
